/**
 * IMPORTS
 */

// domain / entities / user

// typings
import { ICreateClientResponse } from "@/data/dtos/response-api/users/post-create-client-complet-response-api";
import { ICreateClientPayload } from "@/data/dtos/users/post-create-client-complet-dto";
// domain / erro de aplicação
import { AppError } from "@/domain/errors/app-error";
// doamin / repositories / user-create
import { IPostCreateClientCompletRepository } from "@/domain/repositories/users/post-create-client-complet-repository-contract";

/**
 * Caso de uso responsável por criar um novo usuário.
 */
export class PostCreateClientCompletUseCase {
  private readonly repository: IPostCreateClientCompletRepository;

  constructor(createRepository: IPostCreateClientCompletRepository) {
    this.repository = createRepository;
  }
  async execute(data: ICreateClientPayload): Promise<ICreateClientResponse> {
    if (!data || Object.keys(data).length === 0) {
      throw new AppError("Dados inválidos para criação do usuário!");
    }

    return this.repository.createClientComplet(data);
  }
}
